import { Suspense, lazy } from "react";

const Page = lazy(() => import("./FeedSettings").then((m) => ({ default: m.FeedSettings })));

export const FeedSettingsPage = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

FeedSettingsPage.title = "Data feed";
FeedSettingsPage.path = "/feed";
FeedSettingsPage.exact = true;
FeedSettingsPage.menuSection = "sharing";
